import AdaptiveDatePicker from "app/components/AdaptiveDatePicker";
import { CalendarIcon } from "app/components/Icons";
import React, { useEffect, useState } from "react";
import { dateFormatter } from "utils/helpers";
import StatusSelectionButton from "./StatusSelectionButton";
import clsx from "clsx";
import { dropdownTriggerClassname } from "app/components/Dropdown";

interface DueDateSelectionProps {
  dueDate?: string;
  endDate?: string;
  onDateChange?: (val?: string) => void;
}

const DueDateSelection: React.FC<DueDateSelectionProps> = ({
  dueDate,
  onDateChange,
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleChange = (val: Date | null) => {
    setSelectedDate(val);
    if (onDateChange) {
      onDateChange(val ? val.toISOString() : undefined);
    }
  };
  
  useEffect(() => {
    if (dueDate) {
      const parsed = new Date(dueDate);
      if (!isNaN(parsed.getTime())) {
        setSelectedDate(parsed);
      }
    } else {
      setSelectedDate(null);
    }
  }, [dueDate]);

  return (
    <AdaptiveDatePicker
      value={selectedDate}
      onChange={handleChange}
      trigger={
        <button className={clsx("flex items-center justify-between w-full px-2 py-2 rounded-md ",dropdownTriggerClassname)}>
          <StatusSelectionButton
            label="Due date:"
            selectedLabel={
              selectedDate ?  dateFormatter(selectedDate) : "-"
            }
            icon={<CalendarIcon size={20} color="#79808A" />}
            className="text-[12px] leading-[18px] font-medium text-secondary mt-[2px]"
          />
        </button>
      }
      isDisablePastDate={true}
    />
  );
};

export default DueDateSelection;
